import React from 'react';
import { cn } from '../../design-system/cn';
import { motion } from '../../design-system/tokens';

export function Skeleton({ className }) {
  return (
    <div className={cn('rounded-xl bg-gray-800', motion.pulse, className)} aria-hidden />
  );
}

export function SkeletonCard({ lines = 3, className }) {
  return (
    <div
      className={cn(
        'rounded-xl bg-gray-900/60 border border-gray-800/80 p-4 space-y-3',
        motion.pulse,
        className,
      )}
      aria-hidden
    >
      <Skeleton className="h-4 w-1/3" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className="h-3 w-full" />
      ))}
    </div>
  );
}
